import { useUnderwritingStore } from '../../store/underwritingStore'
import { formatCurrency } from '../../utils/currencyUtils'

const fmt = (n) => formatCurrency(Math.abs(n))

export default function CashFlowTable() {
  const { getAllResults, activeScenario } = useUnderwritingStore()
  const all = getAllResults()

  const scenarios = [
    { key: 'best',  label: 'Best Case',  color: '#1d4ed8', bg: '#eff6ff' },
    { key: 'base',  label: 'Base Case',  color: '#1d4ed8', bg: '#eff6ff' },
    { key: 'worst', label: 'Worst Case', color: '#1e3a8a', bg: '#eff6ff' },
  ]

  return (
    <div className="uw-cf-container">
      <h3 className="uw-section-title">5-Year Cash Flow Projection</h3>
      <p className="uw-cf-desc">
        Annual projections across all three scenarios. NOI grows at scenario-specific rent growth rates.
        Exit in Year 5 at projected cap rate — sale proceeds included in Year 5 cash flow.
      </p>

      {scenarios.map(sc => {
        const data = all[sc.key]
        const totalCF = data.table.reduce((sum, r) => sum + r.cashFlow, 0)
        return (
          <div key={sc.key} className={`uw-cf-scenario ${activeScenario === sc.key ? 'uw-cf-scenario--active' : ''}`}
            style={{ borderColor: sc.color }}>
            <div className="uw-cf-scenario-header" style={{ background: sc.bg, borderColor: sc.color }}>
              <span className="uw-cf-scenario-label" style={{ color: sc.color }}>{sc.label}</span>
              <span className="uw-cf-scenario-totals">
                <span>NOI Yr1: <strong>{formatCurrency(data.noi)}</strong></span>
                <span>IRR: <strong>{(data.irr * 100).toFixed(1)}%</strong></span>
                <span>Total CF: <strong style={{ color: totalCF >= 0 ? '#1d4ed8' : '#1e3a8a' }}>
                  {totalCF >= 0 ? '+' : '-'}{fmt(totalCF)}
                </strong></span>
              </span>
            </div>

            <div className="uw-cf-table-wrap">
              <table className="uw-cf-table">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>NOI</th>
                    <th>Debt Service</th>
                    <th>Cash Flow</th>
                    <th>Loan Balance</th>
                    <th>CF Visual</th>
                  </tr>
                </thead>
                <tbody>
                  {data.table.map(row => {
                    const barPct = Math.min(100, Math.max(0, (row.cashFlow / 300_000) * 100))
                    const cfPos = row.cashFlow >= 0
                    return (
                      <tr key={row.year}>
                        <td className="uw-cf-year">Yr {row.year}</td>
                        <td>{fmt(row.noi)}</td>
                        <td className="uw-cf-debt">{fmt(row.debtService)}</td>
                        <td className={cfPos ? 'uw-cf-pos' : 'uw-cf-neg'}>
                          {cfPos ? '+' : '-'}{fmt(row.cashFlow)}
                        </td>
                        <td className="uw-cf-balance">{fmt(row.balance)}</td>
                        <td className="uw-cf-bar-cell">
                          <div className="uw-cf-bar-wrap">
                            <div
                              className={`uw-cf-bar ${cfPos ? 'uw-cf-bar--pos' : 'uw-cf-bar--neg'}`}
                              style={{ width: `${barPct}%`, background: sc.color }}
                            />
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )
      })}

      <div className="uw-cf-note">
        Year 5 includes projected sale proceeds based on Year 5 NOI divided by exit cap rate, minus remaining loan balance.
        All figures are before tax. Consult a tax advisor for after-tax projections.
      </div>
    </div>
  )
}
